/**
 * 品牌配置单一数据源。
 *
 * 通过构建期 env 变量注入，供白标 / 多客户构建定制品牌名、浏览器标题与 Logo：
 *  - REACT_APP_BRAND_NAME      应用内品牌名，覆盖 i18n common.appName（留空回退 i18n）
 *  - REACT_APP_BRAND_LOGO_URL  品牌 Logo 图片 URL（留空回退内置 SVG）
 *
 * env 变量在构建期由 CRA 内联，运行时为静态值，因此这里读取一次即可。
 */

const rawBrandName = (process.env.REACT_APP_BRAND_NAME ?? '').trim()
const rawLogoUrl = (process.env.REACT_APP_BRAND_LOGO_URL ?? '').trim()

export const brandConfig = {
  /** env 配置的品牌名；空串表示未配置，调用方应回退到 i18n 默认值。 */
  name: rawBrandName,
  /** env 配置的 Logo 图片 URL；空串表示未配置，渲染内置 SVG。 */
  logoUrl: rawLogoUrl,
} as const

/**
 * 取生效的品牌名：env 优先，未配置时回退到传入的 i18n 默认值。
 */
export function resolveBrandName(i18nFallback: string): string {
  return brandConfig.name || i18nFallback
}

/**
 * 由品牌名 + 后缀派生浏览器标题。后缀为空时仅返回品牌名。
 */
export function buildDocumentTitle(name: string, suffix: string): string {
  const trimmedSuffix = suffix.trim()
  return trimmedSuffix ? `${name} ${trimmedSuffix}` : name
}
